import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNotes: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="notes"><path d="M3.25 12H5.25M9.75 12H12.25M9.75 8.25H14.25M3.25 8.25H5.25M3.25 15.75H5.25M4.25 3.25H19.75V20.75H4.25V3.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconNotes;
